import {connect} from "react-redux";
import CalendarSubscription from "./CalendarSubscription";
import {compose} from "redux";
import {getPrices, savePrices, updaterPriceType} from "./actions";
import {withRouter} from "react-router-dom";
import {getPriceTypesSelector, getUserRoleSelector} from "../../globalState/app/selectros";
import {getPriceTypes} from "../../globalState/object/actions";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";
import {getCalendarSubscription} from "./selector";

let mapStateToProps = (state) => {
    return {
        calendar: getCalendarSubscription(state),
        userRole: getUserRoleSelector(state),
        priceTypes: getPriceTypesSelector(state),
    }
};


export default compose(connect(mapStateToProps, {
    getPrices,
    updaterPriceType,
    savePrices,
    getPriceTypes
}), withRouter, WithSavingSnackBar)(CalendarSubscription);



